import { InfiniteData, useQueryClient } from "@tanstack/react-query";
import { ComponentType } from "../../../constants";
import { useOptimisticUpdateMutation } from "../../../hooks/useOptimisticUpdateMutation";
import ComponentsService from "../../../services/ComponentsService";
import { INFINITE_PAGINATED_DATA_UPDATERS } from "../../../utils/optimisticUpdate";

import { PaginatedListOfComponentTemplateDto } from "@growth-machine-llc/stridist-api-client";
import { COMPONENT_TEMPLATE_QUERY_KEY } from "../../component-template/ComponentTemplateDialog";
import { COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY } from "../ComponentTemplateLibrary";

export const useUpdateLibraryComponentTemplate = (
  templateId: string,
  componentType: ComponentType,
) => {
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    successToastMessage: "Template updated.",
    queryKey: [COMPONENT_TEMPLATES_LIBRARY_QUERY_KEY, { componentType }],
    exactQueryKey: false,
    mutationFn: ComponentsService.updateComponentTemplate,
    optimisticUpdater: {
      updateFn: (
        oldData: InfiniteData<PaginatedListOfComponentTemplateDto>,
        newData,
        _,
      ) => {
        return INFINITE_PAGINATED_DATA_UPDATERS.updateItemProperties(
          oldData,
          newData.id,
          { ...newData },
        ) as InfiniteData<PaginatedListOfComponentTemplateDto>;
      },
    },
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [COMPONENT_TEMPLATE_QUERY_KEY, { templateId }],
          exact: true,
        });
      },
    },
  });
};
